import { SelectGroup } from "@/components/Pages/Scout/elements/MultiSelectListPopover/GroupPopover/types";

export const activitySelectGroupItems: SelectGroup[] = [
  {
    item: {
      label: "学術成果",
      value: "学術成果"
    },
    subItems: [
      {
        label: "首席",
        value: "首席",
        parent: "学術成果"
      },
      {
        label: "奨学金",
        value: "奨学金",
        parent: "学術成果"
      },
      {
        label: "学会",
        value: "学会",
        parent: "学術成果"
      },
      {
        label: "表彰経験",
        value: "表彰経験",
        parent: "学術成果"
      },
      {
        label: "ゼミ > 設立",
        value: "ゼミ > 設立",
        parent: "学術成果"
      },
      {
        label: "ゼミ > 幹部",
        value: "ゼミ > 幹部",
        parent: "学術成果"
      },
      {
        label: "ゼミ > 代表",
        value: "ゼミ > 代表",
        parent: "学術成果"
      },
      {
        label: "その他（学術成果）",
        value: "その他（学術成果）",
        parent: "学術成果"
      }
    ]
  },
  {
    item: {
      label: "国際経験",
      value: "国際経験"
    },
    subItems: [
      {
        label: "留学 > 半年未満",
        value: "留学 > 半年未満",
        parent: "国際経験"
      },
      {
        label: "留学 > 半年以上1年未満",
        value: "留学 > 半年以上1年未満",
        parent: "国際経験"
      },
      {
        label: "留学 > 1年以上",
        value: "留学 > 1年以上",
        parent: "国際経験"
      },
      {
        label: "帰国子女",
        value: "帰国子女",
        parent: "国際経験"
      },
      {
        label: "その他（国際経験）",
        value: "その他（国際経験）",
        parent: "国際経験"
      }
    ]
  },
  {
    item: {
      label: "コンテスト・コンペティション",
      value: "コンテスト・コンペティション"
    },
    subItems: [
      {
        label: "ビジコン > 出場",
        value: "ビジコン > 出場",
        parent: "コンテスト・コンペティション"
      },
      {
        label: "ビジコン > 入賞",
        value: "ビジコン > 入賞",
        parent: "コンテスト・コンペティション"
      },
      {
        label: "ビジコン > 優勝",
        value: "ビジコン > 優勝",
        parent: "コンテスト・コンペティション"
      },
      {
        label: "ロボコン > 出場",
        value: "ロボコン > 出場",
        parent: "コンテスト・コンペティション"
      },
      {
        label: "ロボコン > 入賞",
        value: "ロボコン > 入賞",
        parent: "コンテスト・コンペティション"
      },
      {
        label: "ロボコン > 優勝",
        value: "ロボコン > 優勝",
        parent: "コンテスト・コンペティション"
      },
      {
        label: "ハッカソン > 出場",
        value: "ハッカソン > 出場",
        parent: "コンテスト・コンペティション"
      },
      {
        label: "ハッカソン > 入賞",
        value: "ハッカソン > 入賞",
        parent: "コンテスト・コンペティション"
      },
      {
        label: "ハッカソン > 優勝",
        value: "ハッカソン > 優勝",
        parent: "コンテスト・コンペティション"
      },
      {
        label: "競技プログラミング > 出場",
        value: "競技プログラミング > 出場",
        parent: "コンテスト・コンペティション"
      },
      {
        label: "競技プログラミング > 入賞",
        value: "競技プログラミング > 入賞",
        parent: "コンテスト・コンペティション"
      },
      {
        label: "競技プログラミング > 優勝",
        value: "競技プログラミング > 優勝",
        parent: "コンテスト・コンペティション"
      },
      {
        label: "データ分析コンペ > 出場",
        value: "データ分析コンペ > 出場",
        parent: "コンテスト・コンペティション"
      },
      {
        label: "データ分析コンペ > 入賞",
        value: "データ分析コンペ > 入賞",
        parent: "コンテスト・コンペティション"
      },
      {
        label: "データ分析コンペ > 優勝",
        value: "データ分析コンペ > 優勝",
        parent: "コンテスト・コンペティション"
      },
      {
        label: "その他（コンテスト・コンペティション）",
        value: "その他（コンテスト・コンペティション）",
        parent: "コンテスト・コンペティション"
      }
    ]
  },
  {
    item: {
      label: "実務経験・インターンシップ・アルバイト",
      value: "実務経験・インターンシップ・アルバイト"
    },
    subItems: [
      {
        label: "有償長期インターン",
        value: "有償長期インターン",
        parent: "実務経験・インターンシップ・アルバイト"
      },
      {
        label: "起業・経営",
        value: "起業・経営",
        parent: "実務経験・インターンシップ・アルバイト"
      },
      {
        label: "制作活動（展示会出展相当）",
        value: "制作活動（展示会出展相当）",
        parent: "実務経験・インターンシップ・アルバイト"
      },
      {
        label: "インフルエンサー（フォロワー1万人以上）",
        value: "インフルエンサー（フォロワー1万人以上）",
        parent: "実務経験・インターンシップ・アルバイト"
      },
      {
        label: "アルバイト",
        value: "アルバイト",
        parent: "実務経験・インターンシップ・アルバイト"
      },
      {
        label: "その他（実務経験・インターンシップ・アルバイト）",
        value: "その他（実務経験・インターンシップ・アルバイト）",
        parent: "実務経験・インターンシップ・アルバイト"
      }
    ]
  },
  {
    item: {
      label: "社会貢献・ボランティア",
      value: "社会貢献・ボランティア"
    },
    subItems: [
      {
        label: "社会奉仕活動（NPO、JICA、自治体振興）",
        value: "社会奉仕活動（NPO、JICA、自治体振興）",
        parent: "社会貢献・ボランティア"
      },
      {
        label: "文化振興活動（学芸員）",
        value: "文化振興活動（学芸員）",
        parent: "社会貢献・ボランティア"
      },
      {
        label: "プロ活動（アスリート、ミュージシャン）",
        value: "プロ活動（アスリート、ミュージシャン）",
        parent: "社会貢献・ボランティア"
      },
      {
        label: "その他（社会貢献・ボランティア）",
        value: "その他（社会貢献・ボランティア）",
        parent: "社会貢献・ボランティア"
      }
    ]
  },
  {
    item: {
      label: "部活・サークル・学生団体など",
      value: "部活・サークル・学生団体など"
    },
    subItems: [
      {
        label: "部活 > 大学体育会",
        value: "部活 > 大学体育会",
        parent: "部活・サークル・学生団体など"
      },
      {
        label: "部活 > 大学文化系",
        value: "部活 > 大学文化系",
        parent: "部活・サークル・学生団体など"
      },
      {
        label: "部活 > 表彰経験",
        value: "部活 > 表彰経験",
        parent: "部活・サークル・学生団体など"
      },
      {
        label: "部活 > 中高部活動",
        value: "部活 > 中高部活動",
        parent: "部活・サークル・学生団体など"
      },
      {
        label: "部活 > 中高主将・副主将",
        value: "部活 > 中高主将・副主将",
        parent: "部活・サークル・学生団体など"
      },
      {
        label: "部活 > 全国大会出場",
        value: "部活 > 全国大会出場",
        parent: "部活・サークル・学生団体など"
      },
      {
        label: "サークル > メンバー",
        value: "サークル > メンバー",
        parent: "部活・サークル・学生団体など"
      },
      {
        label: "サークル > 幹部",
        value: "サークル > 幹部",
        parent: "部活・サークル・学生団体など"
      },
      {
        label: "サークル > 代表",
        value: "サークル > 代表",
        parent: "部活・サークル・学生団体など"
      },
      {
        label: "サークル > 設立",
        value: "サークル > 設立",
        parent: "部活・サークル・学生団体など"
      },
      {
        label: "学生団体 > メンバー",
        value: "学生団体 > メンバー",
        parent: "部活・サークル・学生団体など"
      },
      {
        label: "学生団体 > 幹部",
        value: "学生団体 > 幹部",
        parent: "部活・サークル・学生団体など"
      },
      {
        label: "学生団体 > 代表",
        value: "学生団体 > 代表",
        parent: "部活・サークル・学生団体など"
      },
      {
        label: "学生団体 > 設立",
        value: "学生団体 > 設立",
        parent: "部活・サークル・学生団体など"
      },
      {
        label: "その他（就活・サークル・学生団体など）",
        value: "その他（就活・サークル・学生団体など）",
        parent: "部活・サークル・学生団体など"
      }
    ]
  },
  {
    item: {
      label: "資格",
      value: "資格"
    },
    subItems: [
      {
        label: "日商簿記1級",
        value: "日商簿記1級",
        parent: "資格"
      },
      {
        label: "日商簿記2級",
        value: "日商簿記2級",
        parent: "資格"
      },
      {
        label: "公認会計士",
        value: "公認会計士",
        parent: "資格"
      },
      {
        label: "税理士",
        value: "税理士",
        parent: "資格"
      },
      {
        label: "行政書士",
        value: "行政書士",
        parent: "資格"
      },
      {
        label: "弁護士",
        value: "弁護士",
        parent: "資格"
      },
      {
        label: "弁理士",
        value: "弁理士",
        parent: "資格"
      },
      {
        label: "ファイナンシャル・プランナー",
        value: "ファイナンシャル・プランナー",
        parent: "資格"
      },
      {
        label: "宅地建物取引士",
        value: "宅地建物取引士",
        parent: "資格"
      },
      {
        label: "経営学修士（MBA）",
        value: "経営学修士（MBA）",
        parent: "資格"
      },
      {
        label: "秘書検定",
        value: "秘書検定",
        parent: "資格"
      },
      {
        label: "国家公務員Ⅰ種",
        value: "国家公務員Ⅰ種",
        parent: "資格"
      },
      {
        label: "地方公務員上級",
        value: "地方公務員上級",
        parent: "資格"
      },
      {
        label: "教員試験",
        value: "教員試験",
        parent: "資格"
      },
      {
        label: "薬剤師",
        value: "薬剤師",
        parent: "資格"
      },
      {
        label: "1級建築士",
        value: "1級建築士",
        parent: "資格"
      },
      {
        label: "2級建築士",
        value: "2級建築士",
        parent: "資格"
      },
      {
        label: "管理栄養士",
        value: "管理栄養士",
        parent: "資格"
      },
      {
        label: "中小企業診断士",
        value: "中小企業診断士",
        parent: "資格"
      },
      {
        label: "アクチュアリー",
        value: "アクチュアリー",
        parent: "資格"
      },
      {
        label: "ITパスポート",
        value: "ITパスポート",
        parent: "資格"
      },
      {
        label: "マイクロソフトオフィススペシャリスト（MOS）",
        value: "マイクロソフトオフィススペシャリスト（MOS）",
        parent: "資格"
      },
      {
        label: "基本情報技術者",
        value: "基本情報技術者",
        parent: "資格"
      },
      {
        label: "応用情報技術者",
        value: "応用情報技術者",
        parent: "資格"
      },
      {
        label: "情報セキュリティスペシャリスト",
        value: "情報セキュリティスペシャリスト",
        parent: "資格"
      },
      {
        label: "普通自動車第一種",
        value: "普通自動車第一種",
        parent: "資格"
      },
      {
        label: "その他（資格）",
        value: "その他（資格）",
        parent: "資格"
      }
    ]
  },
  {
    item: {
      label: "言語",
      value: "言語"
    },
    subItems: [
      {
        label: "英語 > 英検",
        value: "英語 > 英検",
        parent: "言語"
      },
      {
        label: "英語 > TOEFL",
        value: "英語 > TOEFL",
        parent: "言語"
      },
      {
        label: "英語 > TOEIC",
        value: "英語 > TOEIC",
        parent: "言語"
      },
      {
        label: "英語 > IELTS",
        value: "英語 > IELTS",
        parent: "言語"
      },
      {
        label: "英語 > その他",
        value: "英語 > その他",
        parent: "言語"
      },
      {
        label: "その他言語",
        value: "その他言語",
        parent: "言語"
      }
    ]
  },
  {
    item: {
      label: "ポートフォリオの有無",
      value: "ポートフォリオの有無"
    },
    subItems: [
      {
        label: "デザイン・クリエイティブ",
        value: "デザイン・クリエイティブ",
        parent: "ポートフォリオの有無"
      },
      {
        label: "その他（ポートフォリオの有無）",
        value: "その他（ポートフォリオの有無）",
        parent: "ポートフォリオの有無"
      }
    ]
  },
  {
    item: {
      label: "その他",
      value: "その他"
    },
    subItems: [
      {
        label: "趣味",
        value: "趣味",
        parent: "その他"
      },
      {
        label: "習い事",
        value: "習い事",
        parent: "その他"
      },
      {
        label: "習慣",
        value: "習慣",
        parent: "その他"
      },
      {
        label: "その他",
        value: "その他",
        parent: "その他"
      }
    ]
  }
];
